import { getServerPageGlobalSearchNotes } from 'api/graphql-helper';
import { ISearchResultItem } from 'redux/stores/search';
import client from 'api/apollo-client';
import { Session } from 'next-auth';
import { SUBSITES } from 'constants/subsites';
import { SeoFieldsFragment } from 'api/graphql-types';
import { NextRouter } from 'next/router';

export const getInternalNotes = async (search: string, session: Session): Promise<ISearchResultItem[]> => {
	const domain = getDomain();
	if (domain !== 'gelderland') return [];

	if (!session?.accessToken) {
		return [];
	}

	try {
		const notesResults = await getServerPageGlobalSearchNotes(
			{
				variables: {
					searchValue: search,
					limit: 9999
				},
				context: {
					headers: {
						Authorization: `Bearer ${session.accessToken}`
					}
				}
			},
			client
		);

		const noteItems: ISearchResultItem[] =
			notesResults.props.data.searchNotes?.map((item) => {
				return {
					title: item.title || '',
					date: item.createdAt ? new Date(item.createdAt) : new Date(),
					description: item.note || '',
					slug: item.authorPage || `/${item.documentId}` || ''
				};
			}) || [];

		return noteItems;
	} catch (error) {
		// eslint-disable-next-line no-console
		console.error('getInternalNotes error:', error);
		return [];
	}
};

export const getDomain = () => {
	const currentHost = location.hostname?.includes('localhost') ? 'gelderland.nl' : location.hostname || '';

	let domain = undefined;
	if (currentHost.includes(SUBSITES.EFRO_OOST)) {
		domain = 'efro-oost';
	} else if (currentHost.includes(SUBSITES.OP_OOST)) {
		domain = 'op-oost';
	} else if (currentHost.includes('regioexpres')) {
		domain = 'regio-expres';
	} else {
		domain = 'gelderland';
	}

	return domain;
};

export const getSearchSeo = (router: NextRouter, seoModule?: SeoFieldsFragment): SeoFieldsFragment | undefined => {
	if (router.query?.zoekterm) {
		if (seoModule?.title) {
			return {
				...seoModule,
				title: `${seoModule?.title} - ${router.query.zoekterm}`
			};
		} else {
			return { title: `Zoeken - ${router.query?.zoekterm}` };
		}
	} else if (seoModule) {
		return seoModule;
	}
};
